import { createToast, toastType } from 'Common/ToastHelper';

export const createErrorToast = (
  fetchRecipesError,
  removeIngredientError,
  replaceIngredientError
) => {
  if (fetchRecipesError !== null) {
    createToast(toastType.error, 'Error', getErrorMessage(fetchRecipesError));
  }
  if (removeIngredientError !== null) {
    createToast(
      toastType.error,
      'Error',
      getErrorMessage(removeIngredientError)
    );
  }
  if (replaceIngredientError !== null) {
    createToast(
      toastType.error,
      'Error',
      getErrorMessage(replaceIngredientError)
    );
  }
};

const getErrorMessage = (error) => {
  if (error === null) {
    return null;
  }
  return error.Title && error.Title !== 'Error' ? error.Title : error.Message;
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/helpers/RemoveReplace.js